import styled from "styled-components";


export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  gap: 8px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 32px;
  align-items: center;

  @media screen and (min-width: 960px) and (max-width: 1260px){ 
    gap: 4px;
  }

  >span {
    margin: 0;
    width: 100%;
    margin-right: auto;
  }
`;

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(100px, 1fr) );
  align-items: end;
  gap: 64px;
  width: 100%;

  ${props => props.theme.mediaQuerie.maxWidth.md}{
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
  gap: 32px;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    gap: 16px;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 60vh;
  gap: 32px;
  overflow-y: scroll;
  padding: 0 16px;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    gap: 16px;
    height: auto;
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 16px;

  ${props => props.theme.mediaQuerie.maxWidth.sm} {
    justify-content: space-between;
    width: 100%;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
`;